export const fallbackConfig = {
  cdn: 'cdn.cookielaw.org',
};
